import apiSlice from './apiSlice';

const apiSliceWithTag = apiSlice.enhanceEndpoints({ addTagTypes: ['Charts'] });

const apiChartsSlice = apiSliceWithTag.injectEndpoints({
  endpoints: (builder) => ({
    getCharts: builder.query({
      query: ({ ean, attribute, ordering, word }) => ({
        url: `/community/products/${ean}/tag_cloud/`,
        method: 'GET',
        params: {
          attribute,
          ordering,
          word,
        },
      }),
      providesTags: ['Charts'],
    }),
  }),
});

export const { useGetChartsQuery } = apiChartsSlice;

export default apiChartsSlice;
